const PAYMENT_UNIT_MONTHLY = "MONTHLY";
const DATE_NOW = "00";
import dayjs from 'dayjs';
export var ReccuringUtil;
(function (ReccuringUtil) {
    function nextReccuringDate(paymentUnit, nextReccuringDate, nextReccuringGracePeriod) {
        let base = dayjs();
        switch (paymentUnit) {
            case PAYMENT_UNIT_MONTHLY:
                base = base.add(nextReccuringGracePeriod, 'month');
                break;
            default:
                base = base.add(nextReccuringGracePeriod, 'year');
                break;
        }
        if (DATE_NOW !== nextReccuringDate) {
            base = base.set('date', Math.min(Number(nextReccuringDate), base.endOf('month').daysInMonth()));
        }
        return base;
    }
    ReccuringUtil.nextReccuringDate = nextReccuringDate;
    function endOfReccuringDate(reccuringLimit = 0, paymentUnit, baseDate) {
        const limit = Math.max((reccuringLimit ?? 0) - 1, 0);
        let result = baseDate.clone();
        switch (paymentUnit) {
            case PAYMENT_UNIT_MONTHLY:
                result = result.add(limit, 'month');
                break;
            default:
                result = result.add(limit, 'year');
                break;
        }
        return result;
    }
    ReccuringUtil.endOfReccuringDate = endOfReccuringDate;
    function cycleLabel(paymentUnit, baseDate) {
        return paymentUnit === PAYMENT_UNIT_MONTHLY ? `毎月${baseDate.format('D日')}` : `毎年${baseDate.format('M月D日')}`;
    }
    ReccuringUtil.cycleLabel = cycleLabel;
})(ReccuringUtil || (ReccuringUtil = {}));
export var ShotPayReccuring;
(function (ShotPayReccuring) {
    function calcNextReccuringDate(nextReccuringDate, nextReccuringMonth) {
        return dayjs(nextReccuringDate).add(nextReccuringMonth ?? 0, 'month');
    }
    ShotPayReccuring.calcNextReccuringDate = calcNextReccuringDate;
    function endOfReccuringDate(nextReccuringDate, nextReccuringMonth, reccuringTime) {
        let base = calcNextReccuringDate(nextReccuringDate, nextReccuringMonth);
        return base.add((reccuringTime ?? 1) - 1, 'month');
    }
    ShotPayReccuring.endOfReccuringDate = endOfReccuringDate;
})(ShotPayReccuring || (ShotPayReccuring = {}));
